import instantsearch from "instantsearch.js/es";
import {
  connectClearRefinements,
  connectCurrentRefinements,
  connectHits,
  connectMenu,
  connectPagination,
  connectRefinementList,
  connectSearchBox,
  connectStats,
} from "instantsearch.js/es/connectors";
import history from "instantsearch.js/es/lib/routers/history";
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import { configure, stats } from "instantsearch.js/es/widgets";

import { searchClient } from "./searchClient";
import { regions } from "./regions";
import { districts } from "./districts";

import debounce from "lodash.debounce";

const regionDistricts = {
  auckland: [
    "auckland-city",
    "franklin-auckland",
    "north-shore-city",
    "papakura",
    "rodney",
    "waiheke",
    "waitakere-city",
  ],
  "bay-of-plenty": [
    "opotiki",
    "rotorua",
    "tauranga-city",
    "western-bay-of-plenty",
    "whakatane",
  ],
  canterbury: [
    "ashburton",
    "banks-peninsula",
    "christchurch-city",
    "hurunui",
    "mackenzie",
    "selwyn",
    "timaru-district",
    "waimakariri",
    "waimate",
    "waitaki-canterbury",
  ],
  gisborne: ["gisborne-district"],
  "hawkes-bay": ["central-hawkes-bay", "hastings", "napier-city", "wairoa"],
  "manawatu-whanganui": [
    "horowhenua",
    "manawatu",
    "palmerston-north-city",
    "rangitikei",
    "ruapehu",
    "tararua",
    "whanganui",
  ],
  marlborough: ["marlborough-district"],
  nelson: ["nelson-city"],
  northland: ["far-north", "kaipara", "whangarei"],
  otago: [
    "central-otago",
    "clutha",
    "dunedin-city",
    "queenstown-lakes",
    "waitaki-otago",
  ],
  southland: ["gore", "invercargill-city", "southland-district"],
  taranaki: ["new-plymouth", "south-taranaki", "stratford"],
  tasman: ["tasman-district"],
  waikato: [
    "franklin-waikato",
    "hamilton-city",
    "hauraki",
    "matamata-piako",
    "otarohanga",
    "south-waikato",
    "thames-coromandel",
    "waikato-district",
    "waipa",
    "waitomo",
  ],
  wellington: [
    "carterton",
    "kapiti-coast",
    "lower-hutt-city",
    "masterton",
    "porirua-city",
    "south-wairarapa",
    "upper-hutt-city",
    "wellington-city",
  ],
  "west-coast": ["buller", "grey", "westland"],
};

const sendEventDebounced = debounce((uiState) => {
  gtag("event", "page_view", {
    page_location: window.location.pathname + window.location.search,
  });
  document.querySelector("#save-search-return").value = btoa(
    window.location.href
  );

  if (typeof googletag !== "undefined") {
    googletag.cmd.push(function () {
      googletag.pubads().refresh();
    });
  }
}, 1000);

const indexName = "prod_SERVICES";
const regionFacet = [];
const categoryFacet = [];

let categoryChanged = true;
let subCategoryChanged = false;
let tagChanged = true;
let districtChanged = false;
let searchChanged = false;
let idChanged = false;
let searchBoxEmpty = true;
let categorySelected = "";
let subCategorySelected = "";
let tag = "";
let idSelected = "";
let searchBox = "";
let title = "Event Hire";
let regionSelected = "";
let districtSelected = "";
let categorySaved = "";
let regionSaved = "";
let districtSaved = "";

const encodedCategories = {
  "event-photography": "Event Photography",
  bands: "Bands",
  djs: "DJs",
  "event-staff": "Event Staff",
  catering: "Catering",
  transport: "Transport",
  speakers: "Speakers",
  "wedding-planners": "Wedding Planners",
  "event-management": "Event Management",
  "gifts-and-registries": "Gifts and Registries",
  entertainment: "Entertainment",
  "photo-booths": "Photo Booths",
  "event-styling": "Event Styling",
  "marquee-hire": "Marquee Hire",
  "production-services": "Production services",
};

const encodedRegions = regions;

const encodedDistricts = districts;

const decodedCategories = Object.keys(encodedCategories).reduce((acc, key) => {
  const newKey = encodedCategories[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

const decodedRegions = Object.keys(encodedRegions).reduce((acc, key) => {
  const newKey = encodedRegions[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

const decodedDistricts = Object.keys(encodedDistricts).reduce((acc, key) => {
  const newKey = encodedDistricts[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function getCategorySlug(name) {
  const encodedName = decodedCategories[name] || name;

  return encodedName.split(" ").map(encodeURIComponent).join("+");
}

function getRegionSlug(name) {
  const encodedName = decodedRegions[name] || name;

  return encodedName.split(" ").map(encodeURIComponent).join("+");
}

function getDistrictSlug(name) {
  const encodedName = decodedDistricts[name] || name;

  return encodedName.split(" ").map(encodeURIComponent).join("+");
}

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function getCategoryName(slug) {
  const decodedSlug = encodedCategories[slug] || "";

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

function getRegionName(slug) {
  const decodedSlug = encodedRegions[slug] || slug;

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

function getDistrictName(slug) {
  const decodedSlug = encodedDistricts[slug] || slug;

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

String.prototype.format =
  String.prototype.format ||
  function () {
    "use strict";
    var str = this.toString();
    if (arguments.length) {
      var t = typeof arguments[0];
      var key;
      var args =
        "string" === t || "number" === t
          ? Array.prototype.slice.call(arguments)
          : arguments[0];

      for (key in args) {
        str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
      }
    }

    return str;
  };

export const search = instantsearch({
  searchClient,
  indexName: indexName,
  routing: {
    router: history({
      windowTitle({ category, region, district, query, tags }) {
        const queryTitle = query ? `"${query}"` : "Search Sharedspace Services";
        const emptySearchTitle = "Event Hire";
        const emptySearchDescription =
          "Discover Event Hire services and suppliers.";

        const titles = {
          Bands: "{0}Bands for Hire",
          Catering: "{0}Catering",
          DJs: "{0}DJ Hire",
          Entertainment: "{0}Event Entertainment",
          "Event Management": "{0}Event Management",
          "Event Photography": "{0}Event Photography",
          "Event Staff": "{0}Event Staff",
          "Event Styling": "{0}Event Styling",
          "Gifts and Registries": "{0}Gift Registry",
          "Marquee Hire": "{0}Marquee Hire",
          "Photo Booths": "{0}Photo Booths",
          "Production Services": "{0}Event Production",
          Speakers: "{0}Event Speakers and Presenters",
          Transport: "{0}Event Transport Services",
          "Wedding Planners": "{0}Wedding Planners",
        };

        const categoryTitle = {
          Bands:
            "Discover {0}bands for hire services for your next function, event or celebration.",
          Catering:
            "Discover {0}event catering services for your next function, event or celebration.",
          DJs: "Discover {0}dj's for hire for your next function, event or celebration.",
          Entertainment:
            "Discover {0}event entertainment for your next function, event or celebration.",
          "Event Management":
            "Discover {0}event management service for your next event.",
          "Event Photography":
            "Discover {0}event photography services for your next function, event or celebration.",
          "Event Staff":
            "Discover {0}event staff for your next function, event or celebration.",
          "Event Styling": "Discover {0}event styling for your next event.",
          "Gifts and Registries":
            "Discover {0}gift registries and corporate gifts for your next event.",
          "Marquee Hire": "Discover {0}marquee hire for your next event.",
          "Photo Booths": "Discover {0}photo books for your next event",
          "Production Services":
            "Discover {0}event production services for your next event.",
          Speakers:
            "Discover {0}speakers and presenters for your next function, event or celebration.",
          Transport:
            "Discover {0}event transport services for your next function, event or celebration.",
          "Wedding Planners":
            "Discover {0}wedding planners for your upcoming wedding.",
        };

        const categorySubTitle = {
          Bands:
            "Discover bands for hire services for your next function, event or celebration.",
          Catering:
            "Discover event catering services for your next function, event or celebration.",
          DJs: "Discover dj's for hire for your next function, event or celebration.",
          Entertainment:
            "Discover event entertainment for your next function, event or celebration.",
          "Event Management":
            "Discover event management service for your next event.",
          "Event Photography":
            "Discover event photography services for your next function, event or celebration.",
          "Event Staff":
            "Discover event staff for your next function, event or celebration.",
          "Event Styling": "Discover event styling for your next event.",
          "Gifts and Registries":
            "Discover gift registries and corporate gifts for your next event.",
          "Marquee Hire": "Discover marquee hire for your next event.",
          "Photo Booths": "Discover photo books for your next event",
          "Production Services":
            "Discover event production services for your next event.",
          Speakers:
            "Discover speakers and presenters for your next function, event or celebration.",
          Transport:
            "Discover event transport services for your next function, event or celebration.",
          "Wedding Planners":
            "Discover wedding planners for your upcoming wedding.",
        };

        const categoryDescription = {
          Bands: "Discover {0}bands for hire",
          Catering: "Discover {0}catering services",
          DJs: "Discover {0}dj's  for hire",
          Entertainment: "Discover {0}event entertainment",
          "Event Management": "Discover {0}event management services",
          "Event Photography":
            "Discover {0}event photography services and suppliers",
          "Event Staff": "Discover {0}event staff for hire",
          "Event Styling": "Discover {0}event styling services",
          "Gifts and Registries": "Discover {0}gift registries",
          "Marquee Hire": "Discover {0}marquee hire",
          "Photo Booths": "Discover {0}photo booths",
          "Production Services": "Discover {0}event production services",
          Speakers: "Discover {0}event speakers and presenters",
          Transport: "Discover {0}event transport services",
          "Wedding Planners": "Discover {0}wedding planners",
        };

        document.querySelector("#category-section").classList.remove("hidden");
        document.querySelector("#category-menu").classList.add("hidden");
        document.querySelector("#tags").classList.add("hidden");
        document.querySelector("#category-title").innerHTML = `Event Hire`;
        document.querySelector(
          "#category-description"
        ).innerHTML = `Discover event hire services from around NZ for your next function, event or celebration.`;
        // Add filter display in here.

        if (query) {
          searchBoxEmpty = query ? false : true;
          searchBox = query;
        }

        if (tags && tags.length) {
          tag = `${tags}`;
        }

        if (category) {
          categorySelected = `${category.toLowerCase()}`;
          document.querySelector("#category-header").classList.remove("hidden");
          document.querySelector("#tags").classList.remove("hidden");
        }

        category = category === undefined ? false : category;
        region = region === undefined ? false : region;
        district = district === undefined ? false : district;
        tags = tags === undefined ? [] : tags;

        if (
          (!category && !region && !district && !tags && !tags.length) ||
          (!category && region)
        ) {
          document.querySelector("#category-section").classList.add("hidden");
        }

        if (!category) {
          document.querySelector("#category-menu").classList.remove("hidden");
        }

        if (district) {
          if (category) {
            for (let index in categoryDescription) {
              if (category == index) {
                document
                  .querySelector('meta[name="description"]')
                  .setAttribute(
                    "content",
                    categoryDescription[index].format(district + " ")
                  );
              }
            }
            document.querySelector(
              "#category-description"
            ).innerHTML = `${categorySubTitle[category]}`;
          } else if (category) {
            for (let index in categoryDescription) {
              if (category == index) {
                document
                  .querySelector('meta[name="description"]')
                  .setAttribute(
                    "content",
                    categoryDescription[index].format(district + " ")
                  );
              }
            }
            document.querySelector(
              "#category-description"
            ).innerHTML = `${categorySubTitle[category]}`;
          }

          title = "Search in " + district;
          document.querySelector("#location-label").innerHTML = district;

          for (let index in categoryTitle) {
            if (category == index) {
              title = titles[index].format(district + " ");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(district + " ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(district + " ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format(district + " ");
            }
          }

          if (!category) {
            title = "Spaces available in " + district;
            regionSelected = region;
            districtSelected = "";
            return district + " Event Hire";
          }
        }

        if (region) {
          if (category) {
            for (let index in categoryDescription) {
              if (category == index) {
                document
                  .querySelector('meta[name="description"]')
                  .setAttribute(
                    "content",
                    categoryDescription[index].format(region + " ")
                  );
              }
            }
            document.querySelector(
              "#category-description"
            ).innerHTML = `${categorySubTitle[category]}`;
          }

          title = "Search in " + region;
          document.querySelector("#location-label").innerHTML = region;

          for (let index in categoryTitle) {
            if (category == index) {
              title = titles[index].format(region + " ");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format(region + " ");
            }
          }
          for (let index in categoryTitle) {
            if (category == index) {
              title = titles[index].format(region + " ");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format(region + " ");
            }
          }

          if (!category) {
            title = "Spaces available in " + region;
            return region + " Event Hire";
          }
        }

        if (category) {
          for (let index in categoryDescription) {
            if (category == index) {
              document
                .querySelector('meta[name="description"]')
                .setAttribute("content", categoryDescription[index].format(""));
            }
          }

          title = category;
          document.querySelector(
            "#category-description"
          ).innerHTML = `${categorySubTitle[category]}`;

          for (let index in categoryTitle) {
            if (category == index) {
              title = titles[index].format("");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(" ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(" ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format("");
            }
          }
        }

        if (query) {
          document.querySelector("#category-section").classList.add("hidden");
          document.querySelector("#category-menu").classList.add("hidden");
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", emptySearchDescription);
          return emptySearchTitle;
        }

        document.getElementById("location-label").value = "Select a Location";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", emptySearchDescription);

        return emptySearchTitle;
      },

      createURL({ qsModule, routeState, location }) {
        document
          .querySelector('meta[property="og:url"]')
          .setAttribute("content", location.href);
        document
          .querySelector('meta[property="twitter:url"]')
          .setAttribute("content", location.href);
        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute("href", location.href);
        }
        const urlParts = location.href.match(/^(.*?)\/services\/event-hire/);
        const baseUrl = `${urlParts ? urlParts[1] : ""}/`;
        let breadcrumbCollection = [];
        breadcrumbCollection.push({
          "@type": "ListItem",
          position: 1,
          item: {
            "@id": "/",
            name: "Home",
          },
        });
        breadcrumbCollection.push({
          "@type": "ListItem",
          position: 2,
          item: {
            "@id": "/services",
            name: "Sharedspace services",
          },
        });

        const categoryPath = routeState.category
          ? `${getCategorySlug(routeState.category)}/`
          : "";

        const regionPath = routeState.region
          ? `${getRegionSlug(routeState.region)}/`
          : "";

        const districtPath = routeState.district
          ? `${getDistrictSlug(routeState.district)}/`
          : "";

        const queryParameters = {};

        if (routeState.query) {
          queryParameters.query = encodeURIComponent(routeState.query);
        }
        if (routeState.page !== 1) {
          queryParameters.page = routeState.page;
        }
        if (routeState.tags !== 1) {
          queryParameters.tags = routeState.tags;
        }
        if (routeState.id !== 1) {
          queryParameters.id = routeState.id;
        }

        const queryString = qsModule.stringify(queryParameters, {
          addQueryPrefix: true,
          arrayFormat: "repeat",
        });

        if (categoryPath) {
          breadcrumbCollection.push({
            "@type": "ListItem",
            position: 3,
            item: {
              "@id": `/services/event-hire/${categoryPath}`,
              name: `${routeState.category}`,
            },
          });

          if (categoryPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 4,
              item: {
                "@id": `/services/event-hire/${categoryPath}`,
                name: `${routeState.category}`,
              },
            });
          }

          if (regionPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 5,
              item: {
                "@id": `/services/event-hire/${categoryPath}${regionPath}`,
                name: `${routeState.region}`,
              },
            });
          }

          if (districtPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 6,
              item: {
                "@id": `/services/event-hire/${categoryPath}${regionPath}${districtPath}`,
                name: `${routeState.district}`,
              },
            });
          }
        } else {
          if (regionPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 3,
              item: {
                "@id": `/services/event-hire/${regionPath}`,
                name: `${routeState.region}`,
              },
            });
          }

          if (districtPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 4,
              item: {
                "@id": `/services/event-hire/${regionPath}${districtPath}`,
                name: `${routeState.district}`,
              },
            });
          }
        }

        let breadcrumb = {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbCollection,
        };

        document.querySelector("#sharedspace-ldjson-breadcrumb").innerHTML =
          JSON.stringify(breadcrumb);

        return `${baseUrl}services/event-hire/${categoryPath}${regionPath}${districtPath}${queryString}`;
      },

      parseURL({ qsModule, location }) {
        const pathnameMatches = location.pathname.match(
          /services\/event-hire\/(.*?)\/?$/
        );
        const splitPath = pathnameMatches ? pathnameMatches[1].split("/") : [];
        const category = getCategoryName((splitPath && splitPath[0]) || "");
        let region,
          district = "";

        if (category) {
          region = getRegionName((splitPath && splitPath[1]) || "");
          district = getDistrictName((splitPath && splitPath[2]) || "");
        }

        if (!category) {
          region = getRegionName((splitPath && splitPath[0]) || "");
          district = getDistrictName((splitPath && splitPath[1]) || "");
        }

        let {
          query = "",
          page,
          tags,
          id,
        } = qsModule.parse(location.search.slice(1));

        // `qs` does not return an array when there's a single value.
        tags = Array.isArray(tags) ? tags : [tags].filter(Boolean);
        id = Array.isArray(id) ? id : [id].filter(Boolean);

        return {
          query: decodeURIComponent(query),
          page,
          region,
          district,
          category,
          tags,
        };
      },
    }),

    stateMapping: {
      stateToRoute(uiState) {
        return {
          query: uiState.prod_SERVICES.query,
          category:
            uiState.prod_SERVICES.menu && uiState.prod_SERVICES.menu.category,
          region:
            uiState.prod_SERVICES.menu && uiState.prod_SERVICES.menu.region,
          district:
            uiState.prod_SERVICES.menu && uiState.prod_SERVICES.menu.district,
          id:
            uiState.prod_SERVICES.refinementList &&
            uiState.prod_SERVICES.refinementList.id,
          tags:
            uiState.prod_SERVICES.refinementList &&
            uiState.prod_SERVICES.refinementList.tags,
          page: uiState.prod_SERVICES.page,
        };
      },

      routeToState(routeState) {
        // refer to uiState docs for details: https://www.algolia.com/doc/api-reference/widgets/ui-state/js/
        return {
          // eslint-disable-next-line camelcase
          prod_SERVICES: {
            query: routeState.query,
            menu: {
              category: routeState.category,
              region: routeState.region,
              district: routeState.district,
            },
            refinementList: {
              tags: routeState.tags,
              id: routeState.id,
            },
            page: routeState.page,
          },
        };
      },
    },
  },
});

jQuery("#list-button").on("click", function () {
  jQuery("#listing-grid").removeClass("hidden");
  jQuery(this).removeClass();
  jQuery(this).addClass(
    "shadow-lg -ml-px relative inline-flex items-center py-3 px-6 rounded-l-full border border-primary bg-primary text-sm font-medium text-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
  );
});

// Create the render function
const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams, sendEvent } = renderOptions;

  if (!isFirstRender) {
    document.querySelector("#listing-grid-view").innerHTML = "";
    document.querySelector("#tag-placeholder").classList.add("hidden");
    document
      .querySelector("#listing-grid-view")
      .classList.add(
        "sm:grid-cols-1",
        "md:grid-cols-2",
        "lg:grid-cols-3",
        "2xl:grid-cols-4"
      );
    for (let i = 0; i < 24; i++) {
      let li = document.createElement("li");
      if (i == 7 && hits.length > 7) {
        li.classList.add("advertising", "space-y-2");
        li.innerHTML = `<div class="flex justify-center flex-wrap">
                        <div id='div-gpt-ad-1643764940109-0' style='min-width: 300px; min-height: 250px;'></div>
                        <div class="text-gray-400 text-xs w-full flex justify-center">Advertisement</div>
                        </div>`;
      } else if (i == 14 && hits.length > 14) {
        li.classList.add("advertisting", "space-y-2");
        li.innerHTML = `<div class="flex justify-center flex-wrap">
                        <div id='div-gpt-ad-1643775030507-0' style='min-width: 300px; min-height: 250px;'></div>
                        <div class="text-gray-400 text-xs w-full flex justify-center">Advertisement</div>
                        </div>`;
      } else {
        li.classList.add("listing-hit", "empty-listing-hit", "space-y-2");
        li.innerHTML = `<div class="relative">
                      <div class="aspect-w-12 aspect-h-9 bg-gray-300"></div>
                      <span class="absolute top-2 right-2 inline-flex h-4 items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 w-1/3 bg-300 animate-pulse">
                      </span>
                    </div>
                    <div class="text-gray-400 p-0">
                        <h3 class="truncate text-base font-bold m-0 w-1/2 bg-gray-400 h-4 animate-pulse"></h3>
                        <div class="bg-gray-300 mt-1 h-4 w-1/3 animate-pulse"></div>
                    </div>`;
      }

      document.querySelector("#listing-grid-view").appendChild(li);
    }
    if (!hits.length) {
      document.querySelector("#category-header").classList.remove("hidden");
      document.querySelector("#category-section").classList.remove("hidden");
      document.querySelector("#category-header h1").innerHTML = title;
      return (widgetParams.container.innerHTML = `<ul role="list" id="listing-grid-view" class="listings-grid space-y-12 grid-cols-1 sm:grid sm:gap-x-6 sm:gap-y-6 sm:space-y-0 lg:gap-x-6">
                <li class="text-center mb-2"> Looks like we can't find any services for your current search.</li>
                <li class="text-center mb-2"> Refine your search or browse below for services in your region.</li>
            </ul>
        `);
    }
  }

  if (hits.length) {
    let itemCollection = [];

    if (document.querySelector("#relatedItems")) {
      document.querySelector("#relatedItems").remove();
    }
    let services = document.getElementsByClassName("listing-hit");
    for (let i = 0; i < hits.length; i++) {
      let regionDisplay = "";
      if (Array.isArray(hits[i].regions) && hits[i].regions.length) {
        regionDisplay = hits[i].regions[0];
        if (hits[i].regions.length > 1) {
          regionDisplay += ` + ${hits[i].regions.length - 1} other region${
            hits[i].regions.length - 1 > 1 ? "s" : ""
          }`;
        }
      } else if (typeof hits[i].region === "string") {
        regionDisplay = hits[i].region;
      } else if (Array.isArray(hits[i].region) && hits[i].region.length) {
        regionDisplay = hits[i].region[0];
        if (hits[i].region.length > 1) {
          regionDisplay += ` + ${hits[i].region.length - 1} other region${
            hits[i].region.length - 1 > 1 ? "s" : ""
          }`;
        }
      } else {
        regionDisplay = "";
      }

      let regionForUrl = "";
      if (Array.isArray(hits[i].regions) && hits[i].regions.length) {
        regionForUrl = hits[i].regions[0];
      } else if (typeof hits[i].region === "string") {
        regionForUrl = hits[i].region;
      } else if (Array.isArray(hits[i].region) && hits[i].region.length) {
        regionForUrl = hits[i].region[0];
      } else {
        regionForUrl = "";
      }

      let url = `/services/detail/${hits[i].category
        .replace(/ +/g, "-")
        .toLowerCase()}/${regionForUrl.replace(/ +/g, "-").toLowerCase()}/${
        hits[i].id
      }/${hits[i].title
        .replace("-", "")
        .replace(/ +/g, "-")
        .replace(/  +/g, "-")
        .toLowerCase()}.html`;

      let image = hits[i].image;
      let pathname = new URL(image)?.pathname;

      itemCollection.push({
        "@type": "ItemPage",
        name: `${hits[i].title}`,
        url: `${url}/?objectID=${hits[i].id}&queryID=${hits[i].__queryID}`,
      });

      services[i].classList.remove("empty-listing-hit");
      services[i].innerHTML = `<div id="${hits[i].id}" data-price="${
        typeof hits[i].price !== "undefined" ? hits[i].price : "POA"
      }">
            <div class="relative">
                <div class="aspect-w-12 aspect-h-9">
                    <a class="listing-click-${
                      hits[i].id
                    }" href="${url}/?objectID=${hits[i].id}&queryID=${
        hits[i].__queryID
      }" ${checkMobile() ? `target="_self">` : `target="_blank">`}
                        <img 
                            class="absolute inset-0 h-full w-full shadow-md object-cover"
                            srcset="
                                https://assets.sharedspace.co.nz/cdn-cgi/image/width=320,quality=90,format=auto${pathname}   320w,
                                https://assets.sharedspace.co.nz/cdn-cgi/image/width=320,quality=90,format=auto${pathname}   640w,
                                https://assets.sharedspace.co.nz/cdn-cgi/image/width=450,quality=90,format=auto${pathname}   1280w,
                            "
                            src="https://assets.sharedspace.co.nz/cdn-cgi/image/width=450,quality=90,format=auto${pathname}" 
                            alt="${hits[i].title}" 
                        />
                    </a>
                </div>
                <div class="absolute w-full h-8 bottom-0 bg-opacity-50 px-2 py-2 flex justify-between hits-center select-none bg-black">
                    <div class="leading-4 ml-4">
                        <span class="text-white">${
                          typeof hits[i].formatted_price !== "undefined"
                            ? hits[i].formatted_price
                            : "POA"
                        }</span>
                    </div>
                </div>
            </div>
            <div class="text-default p-0">
                <h3 class="truncate text-base font-bold m-0">
                    <a class="listing-click-${
                      hits[i].id
                    }" href="${url}/?objectID=${hits[i].id}&queryID=${
        hits[i].__queryID
      }" ${checkMobile() ? `target="_self">` : `target="_blank">`}${
        hits[i].title
      }</a>
                </h3>
                <div class="text-gray-400 text-sm">${regionDisplay}</div>
            </div>
        </div>`;
      var listingLink = document.getElementsByClassName(
        `listing-click-${hits[i].id}`
      );

      for (let i = 0; i < listingLink.length; i++) {
        listingLink[i].addEventListener("click", function () {
          sendEvent("click", hits[i], "Service Clicked");
        });
      }
    }

    let collection = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      accessMode: "auditory, tactile, textual, visual, textOnVisual",
      publisher: "Sharedspace",
      mainEntity: {
        "@type": "ItemList",
        itemListElement: itemCollection,
      },
    };

    document.querySelector("#sharedspace-ldjson").innerHTML =
      JSON.stringify(collection);

    let elements = document.getElementsByClassName("empty-listing-hit");

    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }
};

const renderPagination = (renderOptions, isFirstRender) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = renderOptions;

  const container = document.querySelector("#pagination");

  container.innerHTML = `
        <nav class="border-t border-gray-200 px-4 flex items-center justify-between sm:px-0">
        ${
          !isFirstPage
            ? `
                <div class="-mt-px w-0 flex-1 flex">
                    <a href="${createURL(currentRefinement - 1)}" data-value="${
                currentRefinement - 1
              }" class="cursor-pointer border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">
                    <!-- Heroicon name: solid/arrow-narrow-left -->
                    <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                    </svg>
                    Previous
                    </a>
                </div>
                `
            : ""
        }
        <div class="hidden md:-mt-px md:flex">
        ${pages
          .map(
            (page) => `
                <a href="${createURL(page)}" data-value="${page}" class="${
              currentRefinement === page
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } cursor-pointer border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium" >
                    ${page + 1}
                </a>
            `
          )
          .join("")}
            </div>
            ${
              !isLastPage
                ? `
                <div class="-mt-px w-0 flex-1 flex justify-end">
                    <a
                        href="${createURL(currentRefinement + 1)}"
                        data-value="${currentRefinement + 1}"
                        class="cursor-pointer border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    >
                    Next
                    <svg class="ml-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                    </a>
                </div>
                `
                : ""
            }
        </div>
    `;

  [...container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0 });
      refine(event.currentTarget.dataset.value);
    });
  });
};

// Create the render function
const renderMenuLocationSelect = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const select = document.createElement("select");

    select.addEventListener("change", (event) => {
      refine(event.target.value);

      if (widgetParams.attribute == "region") {
        if (districtChanged) {
          document.getElementById("clearDistrictRefinements").click();
          districtChanged = false;
        }
      }
    });

    widgetParams.container.appendChild(select);
  }

  if (widgetParams.attribute == "district") {
    items.forEach(function (item) {
      if (item.isRefined) {
        districtChanged = true;
      }
    });
  }

  const select = widgetParams.container.querySelector("select");
  select.classList.add("form-select");
  select.disabled = !canRefine;

  // Get selected region
  let selectedRegion = "";
  if (document.getElementById("regions")) {
    const regionSelect = document
      .getElementById("regions")
      .getElementsByTagName("select")[0];
    if (regionSelect) {
      // Normalize the selected region to the regionDistricts key
      selectedRegion = decodedRegions[regionSelect.value] || regionSelect.value;
    }
  }

  // Filter districts if a region is selected
  let filteredItems = items;
  if (
    widgetParams.attribute == "district" &&
    selectedRegion &&
    regionDistricts[selectedRegion]
  ) {
    // Map slugs to display names
    const allowedDistrictLabels = regionDistricts[selectedRegion].map(
      (slug) => districts[slug]
    );
    filteredItems = items.filter((item) =>
      allowedDistrictLabels.includes(item.label)
    );
  }

  if (
    document.getElementById("regions").getElementsByTagName("select")[0]
      .value == "" &&
    widgetParams.attribute != "region"
  ) {
    select.disabled = true;
    select.innerHTML = `<option value="">See all</option>`;
    return;
  }

  select.innerHTML = `
        <option value="">See all</option>
        ${filteredItems
          .map(
            (item) =>
              `<option
                    value="${item.value}"
                    ${item.isRefined ? "selected" : ""}
                >
                    ${item.label}
                </option>`
          )
          .join("")}
        `;
};

// Define custom category order
const categoryOrder = [
  "Entertainment",
  "Event Photography",
  "Event Styling",
  "Photo Booths",
  "Bands",
  "Catering",
  "DJs",
  "Event Management",
  "Event Staff",
  "Gifts and Registries",
  "Marquee Hire",
  "Production Services",
  "Speakers",
  "Transport",
  "Wedding Planners",
];

const renderCategoryMenu = (renderOptions, isFirstRender) => {
  const {
    items,
    refine,
    createURL,
    isShowingMore,
    canToggleShowMore,
    toggleShowMore,
    widgetParams,
  } = renderOptions;

  const categoryIcons = {
    Bands:
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/musician.svg" alt="Bands sub category" />',
    Catering:
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/cook.svg" alt="Catering sub category" />',
    DJs: '<img style="width: 31px; min-width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/dj.png" alt="DJ sub category" />',
    Entertainment:
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/entertainment.svg" alt="Entertainment sub category" />',
    "Event Management":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/event-management.svg" alt="Event Management sub category" />',
    "Event Photography":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/photography.svg" alt="Event Photography sub category" />',
    "Event Staff":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/event-staff.svg" alt="Event Staff sub category" />',
    "Event Styling":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/event-styling.svg" alt="Event Styling sub category" />',
    "Gifts and Registries":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/gift.svg" alt="Gifts and Registries sub category" />',
    "Marquee Hire":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/marquee-hire.svg" alt="Marquee Hire sub category" />',
    "Photo Booths":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/photo-booths.svg" alt="Photo Booths sub category" />',
    "Production Services":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/production-services.svg" alt="Production services sub category" />',
    Speakers:
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/speaker.svg" alt="Speaker sub category" />',
    Transport:
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/car.svg" alt="Transport sub category" />',
    "Wedding Planners":
      '<img style="width: 31px;" class="flex-shrink-0" src="https://assets.sharedspace.co.nz/images/svgs/wedding-planner.svg" alt="Wedding Planner sub category" />',
  };

  if (!isFirstRender) {
    document.querySelector("#category-menu > div").innerHTML = "";
    for (let i = 0; i < 20; i++) {
      let div = document.createElement("div");
      div.classList.add("category", "empty-category", "text-center", "px-2");
      div.innerHTML = `<div class="image flex justify-center">
                <div class="h-12 bg-gray-300 w-14 object-cover object-center"></div>
              </div>
              <h5 class="mx-auto w-1/2 h-2 animate-pulse bg-gray-300 mt-2">
              </h5>`;
      document.querySelector("#category-menu > div").appendChild(div);
    }

    if (!items.length) {
      return (widgetParams.container.innerHTML = `<div>
            <div class="category text-center px-2">No menu options available</div></div>`);
    }
  }

  if (items.length) {
    let menus = document.getElementsByClassName("category");
    for (let i = 0; i < menus.length; i++) {
      if (items[i]) {
        menus[i].classList.remove("empty-category");
        menus[i].innerHTML = `
            <a data-value="${items[i].value}" href="${createURL(
          items[i].value
        )}">
                <div class="image flex justify-center mb-2">
                    ${categoryIcons[items[i].label]}
                </div>
                <h5 class="text-xs">
                    ${items[i].label}
                </h5>
            </a>`;
      }
    }

    let elements = document.getElementsByClassName("empty-category");

    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }

    [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        if (widgetParams.attribute == "category") {
          categorySelected = event.currentTarget.dataset.value;
          categoryChanged = true;
        }

        refine(event.currentTarget.dataset.value);
      });
    });
  }
};

// Create the render function
const renderClearRegionRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear Region refinements";
    button.setAttribute("id", "clearRegionRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

const renderClearDistrictRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear District refinements";
    button.setAttribute("id", "clearDistrictRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

// Create the render function
const createDataAttribtues = (refinement) =>
  Object.keys(refinement)
    .map((key) => `data-${key}="${refinement[key]}"`)
    .join(" ");

const renderListItem = (item) => `
    <div class="ml-2 sm:ml-2 my-1">
      <div class="-m-1 flex flex-wrap items-center">
        <span class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium bg-white">
          <span>
           ${item.refinements
             .map(
               (refinement) =>
                 `<h3 class="inline">${refinement.label}</h3>
                        <button type="button" class="flex-shrink-0 ml-1 h-4 w-4 p-1 mr-2 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500" ${createDataAttribtues(
                          refinement
                        )}>
                            <span class="sr-only">Remove filter for ${
                              refinement.label
                            }</span>
                            <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                              <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                            </svg>
                        </button>`
             )
             .join("")}
            </span>
        </span>
      </div>
    </div>
`;

const renderStats = (renderOptions, isFirstRender) => {
  const {
    nbHits,
    areHitsSorted,
    hitsPerPage,
    nbSortedHits,
    page,
    processingTimeMS,
    query,
    widgetParams,
  } = renderOptions;

  if (isFirstRender) {
    return;
  }

  let count = "";
  if (nbHits > 1) {
    if ((page + 1) * hitsPerPage > nbHits) {
      count += `Showing ${
        page * hitsPerPage + 1
      } - ${nbHits} of ${nbHits} ${categorySelected.toLowerCase()} services`;
    } else if (page >= 1) {
      count += `Showing ${page * hitsPerPage + 1} - ${
        (page + 1) * hitsPerPage
      } of ${nbHits} ${categorySelected.toLowerCase()} services`;
    } else {
      count += `Showing 1 - ${
        (page + 1) * hitsPerPage
      } of ${nbHits} ${categorySelected.toLowerCase()} services`;
    }
  } else if (nbHits === 1) {
    count += `Showing 1 ${categorySelected} service`;
  } else {
    count += `Showing 0 ${categorySelected} services`;
  }

  widgetParams.container.innerHTML = `${count}`;
};

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items, refine, widgetParams } = renderOptions;

  widgetParams.container.innerHTML = `
        ${items.map(renderListItem).join("")}
    `;

  [...widgetParams.container.querySelectorAll("button")].forEach((element) => {
    element.addEventListener("click", (event) => {
      const target = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      if (event.currentTarget.dataset.attribute == "region") {
        document.getElementById("clearRegionRefinements").click();
        document.getElementById("clearDistrictRefinements").click();
        document.getElementById("location-label").innerHTML = "Location";
      }

      if (event.currentTarget.dataset.attribute == "district") {
        document.getElementById("clearDistrictRefinements").click();
      }

      if (event.currentTarget.dataset.attribute == "category") {
        categorySelected = "";
        categoryChanged = true;
      }

      if (event.currentTarget.dataset.attribute == "tags") {
        let array = [];

        items.forEach((item) => {
          if (item.attribute == "tags") {
            item.refinements.forEach((refinement) => {
              array.push(refinement.value);
            });
          }
        });

        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          tag = array.join();
        }
        tagChanged = true;
      }

      if (event.currentTarget.dataset.attribute == "id") {
        let array = [];

        items.forEach((item) => {
          if (item.attribute == "id") {
            item.refinements.forEach((refinement) => {
              array.push(refinement.value);
            });
          }
        });

        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          idSelected = array.join();
        }
        idChanged = true;
      }

      refine(target);
      // Update canonical URL after tag removal
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute("href", window.location.href);
      }
    });
  });
};

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

  if (isFirstRender) {
    const input = document.createElement("input");
    input.setAttribute("class", "form-input-search");
    input.setAttribute("placeholder", "Search Service");

    const button = document.createElement("button");
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

    input.addEventListener("input", (event) => {
      if (event.target.value == "") {
        searchChanged = false;
        searchBoxEmpty = true;
        searchBox = "";
      } else {
        searchChanged = true;
        searchBoxEmpty = false;
        searchBox = event.target.value;
      }

      refine(event.target.value);
    });

    button.addEventListener("click", () => {
      searchBoxEmpty = true;
      clear();
    });

    widgetParams.container.appendChild(input);
    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("input").value = query;
};

const renderMenuCategorySelect = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, widgetParams } = renderOptions;

  widgetParams.container.innerHTML = `
        <div id="${
          widgetParams.attribute
        }Menu" class="relative inline-block text-left w-full sm:w-auto">
            <button data-toggle="dropdown" type="button" class="w-full justify-between sm:w-auto group inline-flex sm:justify-center text-sm font-medium text-gray-700 hover:text-gray-900 sm:pr-0 pr-4" aria-expanded="false">
                ${
                  categorySelected
                    ? '<span class="capitalize">' + categorySelected + "</span>"
                    : '<span class="capitalize">' + widgetParams.attribute
                }</span>

                <!-- Heroicon name: solid/chevron-down -->
                <svg class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>

            <div class="hidden dropdown-menu origin-top-left absolute left-0 mt-4 w-48 shadow-lg bg-white sm:-ml-2 ring-1 ring-black ring-opacity-5 focus:outline-none z-10 h-80 overflow-y-auto">
                <div class="py-1">
                    ${items
                      .map(
                        (item) =>
                          `<label for="filter-category-0" class="${
                            item.isRefined ? "bg-gray-100" : ""
                          } text-gray-default block px-5 py-2 text-sm hover:bg-gray-100 cursor-pointer" ${createDataAttribtues(
                            item
                          )}>
                                ${item.label}
                            </label>`
                      )
                      .join("")}
                </div>
            </div>
        </div>
    `;

  [...widgetParams.container.querySelectorAll("label")].forEach((element) => {
    element.addEventListener("click", (event) => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      if (widgetParams.attribute == "category") {
        tag = "";
        tagChanged = true;
        idSelected = "";
        idChanged = true;
        if (categorySelected == item.value.toLowerCase()) {
          categorySelected = "";
        } else {
          categorySelected = item.value.toLowerCase();
        }
        categoryChanged = true;
      }

      refine(item.value);
    });
  });
};

const renderRefinementList = (renderOptions, isFirstRender) => {
  const { items, isShowingMore, toggleShowMore, refine, widgetParams } =
    renderOptions;

  if (isFirstRender) {
    const ul = document.createElement("ul");
    const button = document.createElement("button");
    button.textContent = "Show more";

    button.addEventListener("click", () => {
      toggleShowMore();
    });

    ul.classList.add("flex", "gap-2", "flex-wrap");
    button.classList.add("mt-4", "underline");

    widgetParams.container.appendChild(ul);
    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("ul").innerHTML = `
        ${items
          .map(
            (item) => `
                <div class="mt-2 divide-y divide-gray-200">
                    <div class="relative flex items-start py-1">
                        <a class="flex justify-between w-full"
                            data-value="${item.value}">
                            <div class="flex items-center h-5">
                                <input id="${item.label}" ${
              item.isRefined ? "checked" : ""
            } type="checkbox" class="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded">
                            </div>
                            <div class="ml-3 min-w-0 flex-1 text-sm">
                                <label for="${
                                  item.label
                                }" class="font-medium text-gray-700 select-none cursor-pointer">
                                    ${
                                      item.label.match(/[A-Z][a-z]+|[0-9]+/g)
                                        ? item.label
                                            .match(/[A-Z][a-z]+|[0-9]+/g)
                                            .join(" ")
                                        : item.label
                                    }
                                </label>
                            </div>
                        </a>
                    </div>
                </div>`
          )
          .join(" ")}
        `;

  widgetParams.container.querySelector("button").textContent = isShowingMore
    ? "Show less"
    : "Show more";

  widgetParams.container.querySelector("button").classList.add("hidden");

  if (items.length >= 5) {
    widgetParams.container.querySelector("button").classList.remove("hidden");
  }

  [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();

      let array = [];

      items.forEach((item) => {
        if (item.isRefined) {
          array.push(item.value);
        }
      });

      if (widgetParams.attribute == "tags") {
        if (array.includes(event.currentTarget.dataset.value)) {
          array = array.filter(function (item) {
            return item !== event.currentTarget.dataset.value;
          });
          tag = array.join();
        } else {
          array.push(event.currentTarget.dataset.value);
          tag = array.join();
        }
        tagChanged = true;
      }

      refine(event.currentTarget.dataset.value);
    });
  });
};

const renderTagRefinementList = (renderOptions, isFirstRender) => {
  const { items, isShowingMore, toggleShowMore, refine, widgetParams } =
    renderOptions;

  if (isFirstRender) {
    const div = document.createElement("div");
    const button = document.createElement("button");
    button.textContent = "Show more";

    button.addEventListener("click", () => {
      toggleShowMore();
    });

    div.classList.add("flex", "space-x-2");
    button.classList.add(
      "underline",
      "underline",
      "flex",
      "flex-shrink-0",
      "ml-2"
    );

    widgetParams.container.appendChild(div);
    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("div").innerHTML = `
      ${items
        .map(
          (item) => `
                  <div class="my-1">
                    <div class="-m-1 flex flex-wrap items-center">
                      <a class="${
                        item.isRefined ? `text-white` : ``
                      } flex cursor-pointer whitespace-nowrap" data-value="${
            item.value
          }">
                        <span ${
                          item.isRefined
                            ? `class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 px-3 text-sm font-semibold bg-primary text-white"`
                            : `class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 px-3 text-sm font-medium bg-white"`
                        }>
                          <h3 class="inline">
                              ${item.label}
                          </h3>
                        </span>
                      </a>
                    </div>
                  </div>`
        )
        .join("")}`;

  widgetParams.container.querySelector("button").textContent = isShowingMore
    ? "Show less"
    : "Show more";

  widgetParams.container.querySelector("button").classList.add("hidden");

  if (items.length >= 24) {
    widgetParams.container.querySelector("button").classList.remove("hidden");
  }

  [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();

      let array = [];

      items.forEach((item) => {
        if (item.isRefined) {
          array.push(item.value);
        }
      });

      if (array.includes(event.currentTarget.dataset.value)) {
        array = array.filter(function (item) {
          return item !== event.currentTarget.dataset.value;
        });
      } else {
        array.push(event.currentTarget.dataset.value);
      }

      refine(event.currentTarget.dataset.value);
    });
  });
};

const customHits = connectHits(renderHits);
const customMenuCategorySelect = connectMenu(renderMenuCategorySelect);
const customCategoryMenu = connectMenu(renderCategoryMenu);
const customMenuLocationSelect = connectMenu(renderMenuLocationSelect);
const customClearRegionRefinements = connectClearRefinements(
  renderClearRegionRefinements
);
const customClearDistrictRefinements = connectClearRefinements(
  renderClearDistrictRefinements
);
const customCurrentRefinements = connectCurrentRefinements(
  renderCurrentRefinements
);
const customPagination = connectPagination(renderPagination);
const customStats = connectStats(renderStats);
const customSearchBox = connectSearchBox(renderSearchBox);
const customTagRefinementList = connectRefinementList(renderTagRefinementList);

searchClient
  .searchForFacetValues([
    {
      indexName,
      params: {
        facetName: "region",
        facetQuery: "",
      },
    },
  ])
  .then(([{ facetHits }]) => {
    regionFacet.push(
      ...facetHits.map((facet) => ({
        ...facet,
        label: facet.value,
        value: facet.value,
        isRefined: false,
        count: 0,
      }))
    );
  });

searchClient
  .searchForFacetValues([
    {
      indexName,
      params: {
        facetName: "category",
        facetQuery: "",
      },
    },
  ])
  .then(([{ facetHits }]) => {
    categoryFacet.push(
      ...facetHits.map((facet) => ({
        ...facet,
        label: facet.value,
        value: facet.value,
        isRefined: false,
        count: 0,
      }))
    );
  });

search.addWidgets([
  configure({
    attributesToSnippet: ["name:7", "description:15"],
    snippetEllipsisText: "…",
    hitsPerPage: 22,
    analytics: true,
    clickAnalytics: true,
  }),

  customHits({
    container: document.querySelector("#hits"),
    escapeHTML: false,
  }),

  stats({
    container: "#stats-button",
    templates: {
      text: `
            {{#areHitsSorted}}
                {{#hasNoSortedResults}}No relevant results{{/hasNoSortedResults}}
                {{#hasOneSortedResults}}1 relevant result{{/hasOneSortedResults}}
                {{#hasManySortedResults}}{{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results{{/hasManySortedResults}}
                sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
            {{/areHitsSorted}}
              {{^areHitsSorted}}
                {{#hasNoResults}}No results{{/hasNoResults}}
                {{#hasOneResult}}1 result{{/hasOneResult}}
                {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} services{{/hasManyResults}}
              {{/areHitsSorted}}
            `,
    },
  }),

  customStats({
    container: document.querySelector("#stats"),
  }),

  customCategoryMenu({
    container: document.querySelector("#category-menu"),
    attribute: "category",
    transformItems: (items) => {
      categoryFacet.forEach((facet, index) => {
        const updatedItem = items.find((item) => item.value === facet.value);
        if (updatedItem) {
          categoryFacet[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });
      // Custom sort by categoryOrder
      return uniqBy([...items, ...categoryFacet], "value").sort(
        (a, b) =>
          categoryOrder.indexOf(a.label) - categoryOrder.indexOf(b.label)
      );
    },
    limit: 100,
  }),

  customMenuLocationSelect({
    container: document.querySelector("#regions"),
    attribute: "region",
    transformItems: (items) => {
      regionFacet.forEach((facet, index) => {
        const updatedItem = items.find((item) => item.value === facet.value);

        if (updatedItem) {
          regionFacet[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });
      return uniqBy([...items, ...regionFacet], "value");
    },
    limit: 100,
  }),

  customMenuLocationSelect({
    container: document.querySelector("#districts"),
    attribute: "district",
    limit: 100,
  }),

  customClearRegionRefinements({
    container: document.querySelector("#clear-refinements-region"),
    includedAttributes: ["region"],
  }),

  customClearDistrictRefinements({
    container: document.querySelector("#clear-refinements-district"),
    includedAttributes: ["district"],
  }),

  customCurrentRefinements({
    container: document.querySelector("#current-refinements"),
  }),

  customPagination({
    container: document.querySelector("#pagination"),
  }),

  customSearchBox({
    container: document.querySelector("#search-box"),
    placeholder: "Search for services",
  }),
  customTagRefinementList({
    container: document.querySelector("#tag-refine"),
    attribute: "tags",
    limit: 7,
    sortBy: ["name:asc"],
    showMore: true,
    showMoreLimit: 100,
  }),
  customMenuCategorySelect({
    container: document.querySelector("#categories"),
    attribute: "category",
    transformItems: (items) => {
      categoryFacet.forEach((facet, index) => {
        const updatedItem = items.find((item) => item.value === facet.value);
        if (updatedItem) {
          categoryFacet[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });
      // Custom sort by categoryOrder
      return uniqBy([...items, ...categoryFacet], "value").sort(
        (a, b) =>
          categoryOrder.indexOf(a.label) - categoryOrder.indexOf(b.label)
      );
    },
    limit: 100,
  }),
]);

search.use(() => ({
  onStateChange({ uiState }) {
    sendEventDebounced(uiState);
  },
  subscribe() {},
  unsubscribe() {},
}));

search.on("render", function () {
  if (document.querySelector("#div-gpt-ad-1643764940109-0")) {
    googletag.cmd.push(function () {
      googletag.display("div-gpt-ad-1643764940109-0");
    });
  }

  if (document.querySelector("#div-gpt-ad-1643775030507-0")) {
    googletag.cmd.push(function () {
      googletag.display("div-gpt-ad-1643775030507-0");
    });
  }
});

window.aa(
  "setUserToken",
  document.querySelector("#identifier").firstChild.nodeValue
);

function checkMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  }

  return false;
}

function ajax(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      resolve(JSON.parse(this.responseText));
    };
    xhr.onerror = reject;
    xhr.open("GET", url);
    xhr.send();
  });
}

function uniqBy(items, property) {
  const seen = {};

  return items.filter((item) => {
    const val = item[property];

    if (seen[val]) {
      return false;
    } else {
      seen[val] = true;
      return true;
    }
  });
}
